import { Injectable } from '@angular/core';
import { SmartService } from '@app/@core/services/smart.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthAppService {
  constructor(private smartService: SmartService) {}

  login(usuario: string, password: string) {
    return this.smartService.add<any>(
      { usuario, password },
      {
        urlRewrite: `${environment.apiUrl}/auth/AuthenticateApplication`,
      }
    );
  }
}
